export class ComingFromSocialQualifier {
    constructor() {
        this.key = "ComingFromSocial";
    }
    process() {
        const referrer = document.referrer.toLowerCase();
        if (referrer.includes("facebook")) {
            return "Facebook";
        }
        if (referrer.includes("/t.co/") || referrer.includes("twitter")) {
            return "Twitter";
        }
        if (referrer.includes("instagram")) {
            return "Instagram";
        }
        if (referrer.includes("linkedin")) {
            return "LinkedIn";
        }
        return "None";
    }
}
